import { render, staticRenderFns } from "./kasteller.vue?vue&type=template&id=b5011888&scoped=true&"
import script from "./kasteller.vue?vue&type=script&lang=js&"
export * from "./kasteller.vue?vue&type=script&lang=js&"
import style0 from "./kasteller.vue?vue&type=style&index=0&id=b5011888&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5011888",
  null
  
)

export default component.exports